import { createVuetify } from 'vuetify'
import { VTimePicker, VCalendar } from 'vuetify/components'
import { de } from 'vuetify/locale'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// --------------------------------------------------
// Themes
// --------------------------------------------------
const light = {
  dark: false,
  colors: {
    primary: '#ff7700ff',
    background: '#FFFFFF',
    surface: '#FFFFFF',
    onBackground: '#474747ff',
  },
}

const dark = {
  dark: true,
  colors: {
    primary: '#FF7500',
    background: '#121212',
    surface: '#222222ff',
    onBackground: '#FFFFFF',
  },
}

// --------------------------------------------------
// HARDENED DEFAULT THEME LOGIC (WICHTIG)
// --------------------------------------------------
const storedTheme = localStorage.getItem('theme')

const prefersDark =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches

const defaultTheme =
  storedTheme === 'dark' || storedTheme === 'light'
    ? storedTheme
    : (prefersDark ? 'dark' : 'light')

// 👉 Müll im localStorage aufräumen
if (storedTheme !== null && storedTheme !== 'dark' && storedTheme !== 'light') {
  localStorage.removeItem('theme')
}

// --------------------------------------------------
// Vuetify Instance
// --------------------------------------------------
export default createVuetify({
  components: {
    VTimePicker,
    VCalendar,
  },

  locale: {
    locale: 'de',
    messages: { de },
  },

  defaults: {
    VAutocomplete: { attach: 'body' },
    VSelect: { attach: 'body' },
    VMenu: { attach: 'body' },
    VTooltip: { attach: 'body' },
    VDatePicker: { attach: 'body' },
  },

  theme: {
    defaultTheme,
    themes: {
      light,
      dark,
    },
  },
})
